export default "__VITE_ASSET__DLdFDY7___"